import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core'
import {MatSnackBar} from '@angular/material'
import {SectionModel} from '../core/model/section.model'
import {Form} from '../core/model/form'
import {ActiveService} from '../core/service/active.service'
import {QuestionModel} from '../core/model/question.model'
import {Observable} from 'rxjs'
import {ProgressService, StateEvent} from '../core/service/progress.service'
import {FormHttp} from '../core/http/form.http'

@Component({
  selector: 'fe-form',
  encapsulation: ViewEncapsulation.None,
  providers: [MatSnackBar],
  templateUrl: './form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: [
    './form.component.scss',
    './material2.scss',
    './dragula.scss',
  ]
})
export class FormComponent implements OnInit {

  @Output() changed: EventEmitter<Form> = new EventEmitter()

  @ViewChild('actions') $actions: ElementRef

  form: Form

  acSection$: Observable<number>

  constructor(private formSv: ActiveService,
              private formHttp: FormHttp,
              private progress: ProgressService,) {
    this.acSection$ = this.formSv.acSection.asObservable()
  }

  ngOnInit() {
    this.getForm()
    this.progress.watch().subscribe((event: StateEvent) => {
      setTimeout(() => this.changed.emit(this.form))
    })
  }

  private getForm() {
    console.log(this.formHttp.get())
    this.formHttp.get().subscribe(f => this.form = f)
  }

  stickActions() {
    this.$actions.nativeElement.style.top = window.scrollY + 'px'
  }

  addQuestion() {
    if (!this.form.sections || !this.form.sections[0]) {
      this.addSection()
      this.formSv.setAcSection(0)
    }

    const idxSection: number = this.formSv.acSection.getValue() || 0
    const section: SectionModel = this.form.sections[idxSection]
    const idxQuestion: number = (this.formSv.acQuestion.getValue() !== undefined
      ? this.formSv.acQuestion.getValue() + 1
      : section.questions.length)
    section.questions.splice(idxQuestion, 0, new QuestionModel({section_id: section.id}))
    this.formSv.setAcQuestion(idxQuestion)
  }

  addSection() {
    const index = this.formSv.acSection.getValue()
    this.form.sections.splice(index + 1, 0, new SectionModel({form_id: this.form.id}))
    this.formSv.setAcSection(index)
  }
}
